const doc = [({"en":({"indexTitle":"Email User Registration"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;